<div class="question-container m-b-1">
 
    <label [innerHTML]="label" [class.required]="isRequired && label" ></label>
  
<mat-form-field appearance="outline" class="form-control-width">
 
    <input matInput
      [matDatepicker]="picker"
      [placeholder]="placeholderText"
      [formControl]="control"/>
      <mat-hint>DD/MM/YYYY</mat-hint>
  <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
  <mat-datepicker #picker></mat-datepicker>
  @if (showError && errorMessages.length) {
    <mat-error>
      @for (msg of errorMessages; track msg) {
        {{ msg }}
      }
    </mat-error>
  }
</mat-form-field>
</div>
